import { FieldDataType } from '@sprinklr/stories/reporting/types';

export const DATE_FILTER_DATA_TYPES: Array<FieldDataType | 'DATE'> = [
    'DATE_HISTOGRAM',
    'DATE',
    'DATETIME',
];
